module.exports = __webpack_public_path__ + "static/media/mario3.0e55fd3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/games/mario3.jpg
// module id = 42
// module chunks = 0